import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackAdLinkingConfirmed.meta';

export const useTrackAdLinkingConfirmed = () => {
  const { track } = useAnalyticsUtilities();

  const trackAdLinkingConfirmed = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackAdLinkingConfirmed };
};
